import Styles from './TableHeaders.module.scss'
import { DefaultType, NameProperty, PropertyType } from 'api/clients/PropertyClient'
import { useProperties } from 'hooks/useProperties'
import { useFinderContext } from 'screens/Finder/FinderContext'
import { reorderProperties } from '../ListProperties'
import { SortingDirection } from 'api/clients/FilesViewsClient'
import { Header } from './Header'
import { Checkbox } from 'screens/Finder/components/Checkbox/Checkbox'
import { useHover } from '@react-aria/interactions'
import { differenceBy, isEmpty } from 'lodash'
import cx from 'classnames'

const TableHeaders = () => {
  const { filesView, handleSort, selectedFiles, handleToggleSelectAll } = useFinderContext()
  const { fromStore } = useProperties()
  const { isHovered, hoverProps } = useHover({})

  if (!filesView) {
    return null
  }

  const sortingDescriptor = {
    sorting_property_id: filesView.schema.sorting_property_id,
    sorting_direction: filesView.schema.sorting_direction,
  }

  const files = filesView.files
  const allSelected = files.length > 0 && isEmpty(differenceBy(files, selectedFiles, 'id'))

  const sortBy = (propertyId: number | null) => {
    let newSortingDirection = SortingDirection.Ascending
    let newSortingPropertyId = propertyId

    if (propertyId === sortingDescriptor.sorting_property_id) {
      newSortingDirection =
        sortingDescriptor.sorting_direction === SortingDirection.Ascending
          ? SortingDirection.Descending
          : SortingDirection.Ascending
    }

    handleSort({
      sorting_direction: newSortingDirection,
      sorting_property_id: newSortingPropertyId,
    })
  }

  const NAME_PROPERTY: NameProperty = {
    id: null,
    name: 'Name',
    default_type: DefaultType.Name,
    is_default: true,
    type: PropertyType.Title,
    property_tag: null,
    workspace_id: 0,
    updated_at: '1970-01-01T00:00:00Z',
    property_values: [],
  }

  const properties = [
    NAME_PROPERTY,
    ...reorderProperties(fromStore(filesView.schema.properties)).filter((prop) => {
      return [DefaultType.Owner, DefaultType.Updated, DefaultType.Created].includes(prop.default_type as DefaultType)
    }),
  ]

  return (
    <div className={Styles.tableHeadersContainer} {...hoverProps}>
      <Checkbox
        id="selectAll"
        onClick={() => handleToggleSelectAll(!allSelected)}
        visible={selectedFiles.length > 0 || isHovered}
        className={cx(Styles.selectAllCheckbox, { [Styles.visiible]: isHovered || selectedFiles.length > 0 })}
        checked={allSelected}
      />
      <div className={Styles.tableHeaders}>
        {properties.map((property) => (
          <Header
            key={property.default_type}
            property={property}
            onClick={() => sortBy(property.id)}
            sortingDirection={
              sortingDescriptor.sorting_property_id === property.id ? sortingDescriptor.sorting_direction : undefined
            }
          />
        ))}
      </div>
    </div>
  )
}

export { TableHeaders }
